declare var tobaccoConstants: any;

export class Constants {
    static readonly YES: string = 'Yes';
    static readonly YES_1: string = 'Yes_1';
    static readonly YES_2: string = 'Yes_2';
    static readonly NO: string = 'No';
    static readonly NO_1: string = 'No_1';
    static readonly NO_2: string = 'No_2';
    static readonly SCREEN_3: number = 0;
    static readonly SCREEN_6: number = 1;
    static readonly SCREEN_7: number = 2;
    static readonly SCREEN_9: number = 3;
    static readonly SCREEN_11: number = 4;
    static readonly SCREEN_12: number = 5;
    static readonly SCREEN_10: number = 6;
    static readonly SCREEN_14: number = 7;
    static readonly SCREEN_15: number = 8;
    static readonly SCREEN_16: number = 9;
    static readonly NEXT_TITLE: string = tobaccoConstants.NextTitle;
    static readonly CHALLENGE_TITLE: string = tobaccoConstants.ChallengeTitle;
    static readonly FOLLOW_UP_TITLE: string = tobaccoConstants.FollowUpTitle;
    static readonly NO_INTERNET: string = tobaccoConstants.NoInternetMessage;
    static readonly GROUP_INDEX_1: number = 0;
    static readonly GROUP_INDEX_2: number = 1;
    static readonly GROUP_INDEX_3: number = 2;
}